<div class="ts-info-container">
  <!-- エリア1＆2：条件指定エリアと年月エリア（横並び） -->
  <div class="top-area">
    <!-- 条件指定エリア -->
    <div class="search-area">
      <div class="search-row">
        <label>年月</label>
        <select [(ngModel)]="selectedYearMonth" (change)="onYearMonthChange()" class="yearmonth-select">
          <option *ngFor="let ym of yearMonthList" [value]="ym">{{ ym }}</option>
        </select>

        <label>スタッフ番号</label>
        <input
          type="text"
          [(ngModel)]="userCode"
          (input)="onUserCodeInput($event)"
          maxlength="11"
          placeholder="XXX-XX-XXXX"
          class="user-code-input"
          autocomplete="off"
        />

        <label>スタッフ番号(Unique)</label>
        <input
          type="text"
          [(ngModel)]="ascUq"
          (input)="onAscUqInput()"
          placeholder="UQ"
          class="asc-uq-input"
          autocomplete="off"
        />

        <button (click)="onDisplay()" [disabled]="!userCode && !ascUq" class="btn-display">表示</button>
        <button (click)="onClear()" class="btn-clear">クリア</button>
        <button class="btn-download" (click)="downloadTimesheetPdf()" [disabled]="!selectedTimesheet">管理台帳出力</button>
      </div>
    </div>
  </div>

  <!-- エリア3：メッセージ表示エリア -->
  <div class="message-area" *ngIf="showMessage">
    <div class="message-text">{{ message }}</div>
  </div>

  <!-- エリア4：リンク表示エリア -->
  <div class="links-area" *ngIf="showLinks">
    <ul class="link-list">
      <li *ngFor="let ts of timesheetList">
        <a (click)="selectTimesheet(ts.timesheetId)" class="link-item">{{ ts.clink }}</a>
      </li>
    </ul>
  </div>

  <!-- エリア5～8：詳細表示エリア -->
  <div class="detail-area" *ngIf="showDetail && selectedTimesheet">
    <!-- エリア5：概要表示エリア（概要表とボタンを横並び） -->
    <div class="overview-container">
      <div class="overview-area">
        <h3>{{ selectedTimesheet.clink }}</h3>
        <table class="overview-table">
          <tr>
            <td class="label-col">TimesheetID</td>
            <td class="data-col">{{ selectedTimesheet.timesheetId }}</td>
            <td class="label-col">TimesheetNo</td>
            <td class="data-col">{{ selectedTimesheet.timesheetNo }}</td>
            <td class="label-col">獲注番号</td>
            <td class="data-col data-col-last"><a (click)="onJobOrderClick(selectedTimesheet.jobOrderId)" class="link-text">{{ selectedTimesheet.jobOrderId }}</a></td>
          </tr>
          <tr>
            <td class="label-col">顧客番号</td>
            <td class="data-col"><a (click)="onCustomerClick(selectedTimesheet.customerOfficeId)" class="link-text">{{ selectedTimesheet.customerOfficeCode }}</a></td>
            <td class="label-col">スタッフ番号</td>
            <td class="data-col"><a (click)="onUserCodeClick(selectedTimesheet.userCode)" class="link-text">{{ selectedTimesheet.userCode }}</a></td>
            <td class="label-col">スタッフ氏名</td>
            <td class="data-col data-col-last">{{ selectedTimesheet.userName }}</td>
          </tr>
          <tr>
            <td class="label-col">業務内容</td>
            <td colspan="5" class="job-title-col">{{ selectedTimesheet.jobTitle }}</td>
          </tr>
        </table>
      </div>

      <!-- 代理申請・代理承認ボタンエリア -->
      <div class="proxy-buttons-area" *ngIf="showProxyButtons()">        <button (click)="onApprovalReturn()" class="btn-download">承認差戻</button>        <button (click)="onProxySubmission()" class="btn-download">代理申請</button>
        <button (click)="onProxyApproval()" class="btn-download">代理承認</button>
      </div>
    </div>

    <!-- エリア6：タイムシート表示エリア -->
    <div class="timesheet-area">
      <h3>タイムシート明細 <span *ngIf="selectedYearMonth">[{{ formatYearMonthDisplay(selectedYearMonth) }}]</span><span *ngIf="selectedTimesheet"> - {{ formatCloseDate(selectedTimesheet.closeDate) }}</span></h3>
      <table class="timesheet-table">
        <thead>
          <tr>
            <th>状態</th>
            <th>日</th>
            <th>開始</th>
            <th>終了</th>
            <th>休憩</th>
            <th>深夜休憩</th>            
            <th class="right">時間(内)</th>
            <th class="right">時間(外)</th>
            <th class="right">深夜(内)</th>
            <th class="right">深夜(外)</th>
            <th class="right">合計</th>            
            <th>在宅</th>
            <th>届出</th>
            <th>経費精算</th>
            <th>金額</th>
            <th>申請者</th>
            <th>申請日</th>
            <th>承認者</th>
            <th>承認日</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of lineItems"
              [ngClass]="{
                'tr_non_submit': item.t1 === '未',
                'tr_submit':     item.t1 === '報',
                'tr_reject':     item.t1 === '否',
                'tr_approve':    item.t1 === '認' || item.t1 === '確'
              }">
            <td>{{ item.t1 }}</td>
            <td [ngClass]="{
                  'day-sat':     item.t2.includes('土'),
                  'day-sun':     item.t2.includes('日'),
                  'day-holiday': item.isHoliday
                }">{{ item.t2 }}</td>
            <td>{{ item.t3 }}</td>
            <td>{{ item.t4 }}</td>
            <td>{{ item.t5 }}</td>
            <td>{{ item.t6 }}</td>
            <td class="right">{{ item.workTimeHours }}</td>
            <td class="right">{{ item.overWorkTimeHours }}</td>
            <td class="right">{{ item.midnightInWorkTimeHours }}</td>
            <td class="right">{{ item.midnightOverWorkTimeHours }}</td>
            <td class="right">{{ item.totalWorkTimeHours }}</td>
            <td>{{ item.t7 }}</td>
            <td>{{ item.t8 }}</td>
            <td>{{ item.t9 }}</td>
            <td>{{ item.t10 }}</td>
            <td>{{ item.t11 }}</td>
            <td>{{ item.t12 }}</td>
            <td>{{ item.t13 }}</td>
            <td>{{ item.t14 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="hosoku">※時間(内)、時間(外)、深夜(内)、深夜(外)の単位は時間です。小数第2位で丸めているため、サマリー（月間合計）とは誤差が生じます。</p>

    <!-- エリア7：サマリー表示エリア -->
    <div class="summary-area" *ngIf="summary">
      <h3>サマリー</h3>
      <table class="summary-table">
        <tr>
          <td class="summary-label">時間内</td>
          <td class="summary-data">{{ toHHMM(summary.workTime) }}</td>
          <td class="summary-label">時間外</td>
          <td class="summary-data">{{ toHHMM(summary.overWorkTime) }}</td>
          <td class="summary-label">深夜</td>
          <td class="summary-data">{{ toHHMM(summary.midnightWorkTime) }}</td>
          <td class="summary-label">合計</td>
          <td class="summary-data">{{ toHHMM(summary.total) }}</td>
          <td class="summary-label">出勤</td>
          <td class="summary-data">{{ summary.attendanceDays }}</td>
          <td class="summary-label">欠勤</td>
          <td class="summary-data">{{ summary.absence }}</td>
          <td class="summary-label">有休</td>
          <td class="summary-data">{{ summary.paidHoliday }}</td>
          <td class="summary-label">在宅</td>
          <td class="summary-data">{{ summary.teleWork }}</td>
        </tr>
      </table>
    </div>

    <!-- エリア8：コメント表示エリア -->
    <div class="comments-area" *ngIf="comments">
      <h3>コメント</h3>
      <table class="comments-table">
        <tr>
          <td class="comment-label">コメント</td>
          <td class="comment-data">{{ comments.comments }}</td>
        </tr>
        <tr>
          <td class="comment-label">訓練記録</td>
          <td class="comment-data">{{ comments.trainingComments }}</td>
        </tr>
        <tr>
          <td class="comment-label">苦情記録</td>
          <td class="comment-data">{{ comments.complaintComments }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
